import { FormReadonlyTheme as DefaultFormReadonlyTheme } from "@acin.reactjs/acin-ui/field";
import { DefaultTheme } from "styled-components";

const FormReadOnlyTheme = (theme: DefaultTheme): DefaultFormReadonlyTheme => ({
  root: {
    fontWeight: theme.typography.fontWeights.bold,
  },
});

export default FormReadOnlyTheme;
